var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},_vm._l((_vm.menus),function(menu,index){return (_vm.isLogin(menu.isLogin))?_c('div',{key:index,staticClass:"sidebarDesktop"},[_c('adx-item',{attrs:{"items":menu.items}})],1):_vm._e()}),0)}
var staticRenderFns = []

export { render, staticRenderFns }